import { useState } from 'react'

import { ExpandMoreRounded } from '@mui/icons-material'
import { alpha, Button, Menu, MenuItem, useTheme } from '@mui/material'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object[]} props.items
 * @param {string} props.items[].label
 * @param {Function} props.items[].onClick
 * @param {React.Element} [props.items[].icon]
 * @param {boolean} [props.disabled]
 * @param {string} [props.size]
 * @param {Object} [props.sx]
 */
export default function MoreButton({ items, disabled = false, size = 'small', sx }) {
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = useState(null)

  return (
    <>
      <Menu
        id="entity-menu"
        variant="menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        slotProps={{ list: { sx: { py: 0 } } }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: -10, horizontal: 'right' }}
      >
        {items.map((item, index) => (
          <MenuItem
            divider={index < items.length - 1}
            key={item.label}
            disabled={!item.onClick}
            size="small"
            onClick={(e) => {
              item.onClick(e)
              setAnchorEl(null)
            }}
            sx={{ py: 1.2, color: 'primary.main' }}
          >
            {item.icon && <item.icon sx={{ mr: 1, fontSize: 18 }} />}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
      <Button
        endIcon={
          <ExpandMoreRounded
            sx={{
              transform: anchorEl ? 'rotate(180deg)' : null,
              transition: theme.transitions.create('transform', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
            }}
          />
        }
        variant="outlined"
        size={size}
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          ...sx,
          backgroundColor: anchorEl ? alpha(theme.palette.primary.main, 0.3) : null,
        }}
      >
        More
      </Button>
    </>
  )
}
